import { render, staticRenderFns } from "./WithdrawalResult.vue?vue&type=template&id=25fbc75e&"
import script from "./WithdrawalResult.vue?vue&type=script&lang=js&"
export * from "./WithdrawalResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports